const cities = [
  'Tetovo',
  'Skopje',
  'Resen',
  'Ohrid',
  'Kriva Palanka',
  'Kavadarci',
  'Berovo',
  'Stip',
  'Gostivar',
  'Delcevo',
  'Radovis',
  'Bitola',
  'Kumanovo',
  'Makedonska Kamenica',
  'Prilep',
  'Valandovo',
  'Veles',
  'Demir Kapija',
  'Gevgelija',
  'Vinica',
  'Strumica',
  'Struga',
  'Star Dojran',
];

export default cities.sort();
